import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Row, Col } from 'antd';
import isEmpty from 'lodash/isEmpty';

import { emitChatsCustomEvent } from '../../../../../../../data/redux/chats_details/actions';
import { emitMemberCustomEvent } from '../../../../../../../data/redux/member_details/actions';
import { updateAgentMonitoringState } from '../../../../../../../data/redux/agent_monitoring_details/actions';

import { APP_LAYOUT, SOCKET_EVENTS } from '../../../../../../../data/config/constants';
import { showMessage, log } from '../../../../../../../data/config/utils';
import { IMG_PERSON, IMG_EMPTY, IMG_CHATTING } from '../../../../../../../data/assets/img';

import ShowMessage from '../../../../../../../components/showmessage';
import ConversationItem from '../../../../../components/conversationitem';
// import ChatItem from '../../../../chats/components/chatitem';
import ChatInterface from '../../../../../components/chatinterface';
import ProfileCard from '../../../../../components/profilecard';

class AgentHandlingChats extends React.PureComponent {
  componentDidMount() {
    this.agent_list_timer = false;
    this.fetchAgentLiveChats();
    this.agent_list_timer = setInterval(this.fetchAgentLiveChats, 5000);
  }

  componentWillUnmount() {
    const { actions } = this.props;
    actions.updateAgentMonitoringState([], 'selected_agent.live_chats');
    this.closeChatInterface();
    if (this.agent_list_timer) {
      clearInterval(this.agent_list_timer);
    }
  }

  fetchAgentLiveChats = () => {
    const { actions, selected_agent } = this.props;
    const payload = { agentPsid: selected_agent.agent.psid };
    actions.emitMemberCustomEvent(SOCKET_EVENTS.GET_AGENT_CHATS, payload, (err, res) => {
      log(err, res);
      if (!err && res && res.data) {
        if (selected_agent.active_chat.chat_item && !res.data[selected_agent.active_chat.chat_item.psid]) {
          this.closeChatInterface();
          showMessage('warning', 'customer has been disconnected');
        }
        actions.updateAgentMonitoringState(res.data, 'selected_agent.live_chats');
      }
    });
  };

  handleChatItemClicked = chat_item => {
    const { admin_id, actions } = this.props;
    const { active_chat } = this.props.selected_agent;
    const payload = {
      psid: chat_item.psid,
      adminId: admin_id
    };
    if (active_chat.chat_item && active_chat.chat_item.psid === chat_item.psid) {
      showMessage('warning', 'chat item has been already joined the chatroom.');
    } else {
      //TODO: replace this with ajax call
      actions.emitChatsCustomEvent(SOCKET_EVENTS.JOIN_ROOM, payload, (err, res) => {
        if (!err && res && res.data) {
          const data = res.data;
          data.chat_item = chat_item;
          const active_chat = {
            chat_item,
            messages: res.data.activeChatSessionLogs ? res.data.activeChatSessionLogs : [],
            profile: res.data.userProfileDetails ? res.data.userProfileDetails : {}
          };
          actions.updateAgentMonitoringState(active_chat, 'selected_agent.active_chat');
        } else if (res.error) {
          showMessage('error', 'unable to join chatroom');
        }
      })
    }
  };

  closeChatInterface = () => {
    const { actions } = this.props;
    const active_chat = {
      chat_item: null,
      messages: [],
      profile: {}
    };
    actions.updateAgentMonitoringState(active_chat, 'selected_agent.active_chat');
  };

  renderChatItems = () => {
    const { admin_id, selected_agent } = this.props;
    if (isEmpty(selected_agent.live_chats)) {
      return (
        <ShowMessage img_src={IMG_EMPTY} title="No live conversations" message="No any live conversation is avaliable" height={140} width={140} />
      );
    }
    return (
      Object.keys(selected_agent.live_chats).map(psid => {
        const chat_item_props = {
          chat_item: selected_agent.live_chats[psid],
          admin_id: admin_id,
          active: selected_agent.active_chat.chat_item && selected_agent.active_chat.chat_item.psid === psid,
          handleChatItemClicked: this.handleChatItemClicked
        };
        return (
          <ConversationItem key={psid} {...chat_item_props} />
        );
      })
    );
  };

  renderAgentProfileCard = () => {
    const { selected_agent } = this.props;
    if (!isEmpty(selected_agent.active_chat.profile)) {
      return (
        <ProfileCard profile_details={selected_agent.active_chat.profile} />
      );
    }
    return (
      <ShowMessage img_src={IMG_PERSON} message="Profile details are not avaliable" height={150} width={80} color='primary' />
    );
  };

  renderSelectedChatItemDetails = () => {
    const { screen_width, selected_agent, isActionPermitted } = this.props;
    const is_mobile = screen_width < 768;
    const is_tablet = screen_width >= 768 && screen_width <= 1024;
    if (selected_agent.active_chat.chat_item) {
      return (
        <Fragment>
          <Col xs={24} md={is_tablet ? 15 : 12} className="ori-full-parent-height">
            <ChatInterface
              isActionPermitted={isActionPermitted}
              messages={selected_agent.active_chat.messages}
              active_chat_item={selected_agent.active_chat.chat_item}
              onClickClose={this.closeChatInterface}
            />
          </Col>
          <Col xs={24} md={6} className={classNames("ori-full-parent-height ori-l-border-light ori-overflow-auto", { "ori-display-none": is_mobile || is_tablet })}>
            {this.renderAgentProfileCard()}
          </Col>
        </Fragment>
      );
    } else if (!is_mobile) {
      return (
        <Col xs={24} md={is_tablet ? 15 : 18} className="ori-full-parent-height">
          <ShowMessage img_src={IMG_CHATTING} title="Conversations" message="Please click on chat item to see live conversation details." height={180} width={200} />
        </Col>
      );
    }
    return null;
  };

  render() {
    const { screen_width, screen_height } = this.props;
    const is_tablet = screen_width >= 768 && screen_width <= 1024;
    return (
      <Row className="ori-overflow-hidden" style={{ height: `${screen_height - APP_LAYOUT.APP_HEADER_HEIGHT - 100}px` }}>
        <Col xs={24} md={is_tablet ? 9 : 6} className="ori-full-parent-height ori-r-border-light ori-overflow-y-auto ori-overflow-x-hidden">
          {this.renderChatItems()}
        </Col>
        {this.renderSelectedChatItemDetails()}
      </Row>
    );
  }
}


const mapStateToProps = state => {
  return {
    screen_width: state.page_details.device_data.screen_width,
    screen_height: state.page_details.device_data.screen_height,
    selected_agent: state.agent_monitoring_details.selected_agent,
    admin_id: state.admin_details.admin_id
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        emitChatsCustomEvent,
        emitMemberCustomEvent,
        updateAgentMonitoringState,
      },
      dispatch
    ),
  };
};

AgentHandlingChats.propTypes = {
  screen_width: PropTypes.number.isRequired,
  screen_height: PropTypes.number.isRequired,
  selected_agent: PropTypes.object,
  agent_live_chats: PropTypes.array,
  admin_id: PropTypes.string,
  actions: PropTypes.object,
  isActionPermitted: PropTypes.func,
};

AgentHandlingChats.defaultProps = {
  agent_live_chats: [],
};

export default connect(mapStateToProps, mapDispatchToProps)(AgentHandlingChats);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/agentmonitoring/components/agenthandlingchats/index.js